import React, { useEffect } from "react";
// import { div, section, Button } from "reactstrap";
import { Link } from "react-router-dom";
import "./index.scss";
import CookiesConsent from "./cookies-consent";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  container: {
    padding: "40px 30px",
  },
  flexEnd: {
    display: "flex",
    justifyContent: "flex-end",
  },
  boldText: {
    fontWeight: "bold",
  },
  ml5: {
    marginLeft: "15px",
  },
  mt5: {
    marginTop: "35px",
  },
  pr5: {
    paddingRight: "20px",
  },
});

const CookiesPolicy = ({ classes }) => {
  let cookieName = "pscweb:cc";

  const setCookies = (name, value, days) => {
    let expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    toggleCookieDisplay();
  };

  const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  const toggleCookieDisplay = () => {
    let cookieObj = getCookie(cookieName);
    console.log(cookieObj, typeof cookieObj);
    let cookieWrapperElement = document.getElementById("cookies-policy-footer");
    if (cookieObj === null) {
      console.log("it is null");
      cookieWrapperElement.style.display = "flex";
    } else {
      console.log("it is not null");
      cookieWrapperElement.style.display = "none";
    }
  };

  useEffect(() => {
    const body = document.body;
    body.style.overflow = "scroll";
    toggleCookieDisplay();
  });
  return (
    <div className={classes.container}>
      <section>
        <div className={classes.flexEnd}>
          <Link to="/privacy-policy" className={classes.pr5}>
            Privacy Policy
          </Link>
          <Link to="/customer-awareness-policy" className={classes.pr5}>
            Customer Awareness Policy
          </Link>
          <Link to="/login">Login</Link>
        </div>
        <div>
          <h2 className={classes.boldText}>Cookie Policy</h2>
        </div>
        <div>
          <p>
            Please read this cookie policy (“cookie policy”, "policy") carefully
            before using this website (“website”, "service") operated by Avitech
            ("us", 'we", "our").
          </p>
        </div>
        <div>
          <h4 className={classes.boldText}>What are Cookies?</h4>
          <p>
            Cookies are simple text files that are stored on your computer or
            mobile device by a website’s server. Each cookie is unique to your
            web browser. It will contain some anonymous information such as a
            unique identifier, website’s domain name, and some digits and
            numbers.
          </p>
        </div>
        <div>
          <h4 className={classes.boldText}>What type of cookies do we use? </h4>
        </div>
        <div>
          <h6 className={classes.boldText}>Necessary Cookies</h6>
        </div>
        <div>
          <p>
            {" "}
            Necessary cookies allow us to offer you the best possible experience
            when accessing and navigating through our website and using its
            features. For example, these cookies let us recognize that you have
            created an account and have logged into that account.
          </p>
          <h6 className={classes.boldText}>Functionality Cookies</h6>
          <p>
            Functionality cookies let us operate the site in accordance with the
            choices you make. For example, we will recognize your username and
            remember how you customized the site during future visits.
          </p>
          <h6 className={classes.boldText}>Performance Cookies</h6>
          <p>
            These are used to gather data on how users use our website and the
            pages visited most often. They monitor only the performance of our
            website as the user interacts with it. All data collected by these
            cookies are anonymous and are solely used to improve the
            functionality of our website.
          </p>
        </div>
        <div>
          <h4 className={classes.boldText}>How to delete Cookies?</h4>
        </div>
        <div>
          <p>
            If you want to restrict or block the cookies that are set by our
            website, you can do so through your browser setting.
          </p>
        </div>
        <div>
          <h4 className={classes.boldText}>Contacting us</h4>
        </div>
        <div>
          <p>
            If you have any questions about this policy or our use of cookies,
            please contact us.{" "}
            <a
              href="mailto:dpo@avitechng.com"
              className="text-decoration: underline; color: inherit;"
            >
              dpo@avitechng.com
            </a>{" "}
          </p>
        </div>
        <div />
      </section>
      <CookiesConsent setCookies={setCookies} cookieName={cookieName} />
    </div>
  );
};

export default withStyles(styles)(CookiesPolicy);



// WEBPACK FOOTER //
// ./src/views/policies/cookies-policy.js